import React from "react";
import "./Product.css";

import machine1 from "../assets/printer1 (1).png";
import toner1 from "../assets/printer1 (3).png";
import powder1 from "../assets/toner1.png";

const Product = () => {
  return (
    <section className="products-section">
      <div className="section-header">
        <h3 className="section-title">Our Premium Printing Solutions</h3>
        <p className="section-subtitle">
          Discover high-quality machines, toners, and powders for flawless prints every time.
        </p>
      </div>

      <div className="products-grid">

        {/* Product 1 */}
        <article className="product-item elegant-style">
          <div className="product-media">
            <img src={machine1} alt="Konica Minolta Digital Printer" className="main-img" />
          </div>

          <div className="product-info">
            <h3 className="product-name">Konica Minolta Digital</h3>
            <p className="product-summary">
              Reliable digital printer built for smooth, fast, and high-detail printing. 
              Ideal for daily business use and commercial workloads.
            </p>

            <div className="cta-group">
              <a href="/about" className="cta-btn primary">About Us</a>
              <a href="/contact" className="cta-btn secondary">Contact Us</a>
            </div>
          </div>
        </article>

        {/* Product 2 */}
        <article className="product-item elegant-style">
          <div className="product-media">
            <img src={toner1} alt="Konica Minolta Toner Cartridge" className="main-img" />
            <div className="badge">New Arrival</div>
          </div>

          <div className="product-info">
            <h3 className="product-name">Konica Minolta Toner</h3>
            <p className="product-summary">
              High-quality toners that provide bright colors, clear print output, 
              and strong page yield for professional and office printing.
            </p>

    

            <div className="cta-group">
              <a href="/about" className="cta-btn primary">About Us</a>
              <a href="/contact" className="cta-btn secondary">Contact Us</a>
            </div>
          </div>
        </article>

        {/* Product 3 */}
        <article className="product-item elegant-style">
          <div className="product-media">
            <img src={powder1} alt="Premium Toner Powder" className="main-img" />
            <div className="badge">Eco Choice</div>
          </div>

          <div className="product-info">
            <h3 className="product-name">Premium Toner Powder</h3>
            <p className="product-summary">
              Refined toner powder ensuring crisp prints performance. 
              Designed for regular office use and heavy-duty printing. 
            </p>

          

            <div className="cta-group">
              <a href="/about" className="cta-btn primary">About Us</a>
              <a href="/contact" className="cta-btn secondary">Contact Us</a>
            </div>
          </div>
        </article>

      </div>
    </section>
  );
};

export default Product;
